import { AppGlobalState } from '../../types'
import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

const ReturnDeclarationSkuSelectors = {
  ...createBasicSelectors('returnDeclarationSku'),
  totalQty: (state: AppGlobalState) => state.returnDeclarationSku.totalQty,
  totalDeliveredQty: (state: AppGlobalState) => state.returnDeclarationSku.totalDeliveredQty,
  totalStandardQty: (state: AppGlobalState) => state.returnDeclarationSku.totalStandardQty,
  totalFinalQty: (state: AppGlobalState) => state.returnDeclarationSku.totalFinalQty,
  printProgress: (state: AppGlobalState) => state.returnDeclarationSku.printProgress,
  declarationCountFetchProgress: (state: AppGlobalState) => state.returnDeclarationSku.declarationCountFetchProgress,
  declarationCountFetchError: (state: AppGlobalState) => state.returnDeclarationSku.declarationCountFetchError,
  declarationCount: (state: AppGlobalState) => state.returnDeclarationSku.declarationCount,
}

export default ReturnDeclarationSkuSelectors
